import type { PERMISSION } from '@/shared/constants/permissions';
import { useSessionStore } from '../model/store';

export const hasPermission = (includedPermissions: PERMISSION[]) => {
  const myPermissions = useSessionStore.getState().permissions;

  return includedPermissions.some((permission) =>
    myPermissions.includes(permission)
  );
};

export const isSuperAdmin = () => {
  const isSuperAdmin = useSessionStore.getState().isSuperAdmin;

  return !!isSuperAdmin;
};

export const isContractor = () => {
  const isContractor = useSessionStore.getState().isContractor;

  return !!isContractor;
};

/**
 * Wage and salary amounts of staff (card 265). The permission alone decides: the organization
 * creator has no bypass here, the same as on the server.
 */
export const canViewWages = () => hasPermission(['STAFF_WAGES_VIEW']);

/** Editing needs viewing, so a role that somehow has only Edit counts as neither. */
export const canEditSalaries = () =>
  hasPermission(['STAFF_SALARY_EDIT']) && canViewWages();
